import React, { useEffect } from 'react';
import { Grid, Modal, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { closeAllFolderModal, getTemplateFolders } from '../../../actions/folders';
import FoldersItems from '../FoldersItems';

function ModalAllFolders({
  onAllFolderModal,
  closeAllFolderModal,
  templateFolders,
  getTemplateFolders,
}) {
  useEffect(() => {
    getTemplateFolders();
  }, []);

  return (
    <React.Fragment>
      <Grid>
        <Grid.Column width={4}>
          <Modal open={onAllFolderModal} closeIcon onClose={closeAllFolderModal}>
            <Modal.Header style={{ textAlign: 'center' }}>Все папки</Modal.Header>
            <Modal.Content>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Название папки</Table.HeaderCell>
                    <Table.HeaderCell>Действия</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {templateFolders.map((folder) => (
                    <FoldersItems key={folder.key} folder={folder} />
                  ))}
                </Table.Body>
              </Table>
            </Modal.Content>
          </Modal>
        </Grid.Column>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { onAllFolderModal, templateFolders } = state.folders;
  return {
    onAllFolderModal,
    templateFolders,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeAllFolderModal: () => dispatch(closeAllFolderModal()),
  getTemplateFolders: () => dispatch(getTemplateFolders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalAllFolders);



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/FoldersModals/ModalAllFolders.js